import { SatelliteGroup } from '../types/satellite';

export interface GroupPreset {
  id: SatelliteGroup;
  label: string;
  description?: string;
}

export const GROUP_PRESETS: GroupPreset[] = [
  { 
    id: "active", 
    label: "Active satellites",
    description: "Currently operational satellites"
  },
  { 
    id: "stations", 
    label: "Space stations",
    description: "International Space Station and other crewed stations"
  },
  { 
    id: "starlink", 
    label: "Starlink",
    description: "SpaceX Starlink constellation (large dataset)"
  },
  { 
    id: "weather", 
    label: "Weather satellites",
    description: "Meteorological and climate monitoring satellites"
  },
  { 
    id: "gps-ops", 
    label: "GPS (operational)",
    description: "Global Positioning System satellites"
  },
];

export const DEFAULT_CONFIG = {
  maxSatellites: 1200,
  updateIntervalMs: 2000,
  defaultGroup: 'active' as SatelliteGroup,
  closeApproach: {
    horizonSec: 600,
    stepSec: 60,
    thresholdKm: 10,
    cellKm: 50,
    maxPairs: 5000,
  },
  groundTracks: {
    maxSatellites: 400,
    stepSec: 60,
    steps: 30, // 30 minutes ahead
  }
};